import { Trans, useLingui } from '@lingui/react/macro';

import InlineText from '@/design_system/Typography/InlineText';
import IconVisibility from '@/icons/Visibility.svg';
import { BaseNotification } from '@/layouts/App/Navbar/NotificationList/components/BaseNotification/BaseNotification';
import type { TNotificationOfType } from '@/models/notification';

export const NewSupervisorAssignmentNotification = ({
  notification,
}: {
  notification: TNotificationOfType<'new_supervisor_assignment'>;
}) => {
  const { t } = useLingui();

  return (
    <BaseNotification
      notificationLabel={t({
        id: 'notification.new-supervisor-assignment.label',
        message: `You have been assigned as the supervisor of the request ${notification.request.reference} by ${notification.data.authorName}`,
      })}
      icon={<IconVisibility on />}
      type="new"
      notification={notification}
      notificationHeader={(color) => (
        <Trans id="notification.new-supervisor-assignment">
          You have been assigned as the supervisor of the request by{' '}
          <InlineText weight="medium" color={color}>
            {notification.data.authorName}
          </InlineText>
        </Trans>
      )}
    />
  );
};
